/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { LinkFieldItemEdit } from "./edit-item";

const LinkFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <LinkFieldItemEdit />
        </FieldListEditWrapper>
    );
};
LinkFieldEdit.displayName = "LinkFieldEdit";
export { LinkFieldEdit };
